export default {
  s: '%d sekund',
  smicro: '%d s',
  smid: '%d sek',

  ss: '%d sekunder',
  ssmicro: '%d s',
  ssmid: '%d sek',

  m: '%d minut',
  mmicro: '%d m',
  mmid: '%d min',

  mm: '%d minuter',
  mmmicro: '%d m',
  mmmid: '%d min',

  h: '%d timme',
  hmicro: '%d t',
  hmid: '%d timme',

  hh: '%d timmar',
  hhmicro: '%d t',
  hhmid: '%d timmar',

  d: '%d dag',
  dmicro: '%d d',
  dmid: '%d dag',

  dd: '%d dagar',
  ddmicro: '%d d',
  ddmid: '%d dagar',
};
